import TrackingLink from '../TrackingLink'


export const GemsRace = () => {
    return (
        <>
            <span>Princess Races este secțiunea dedicată turneelor organizate de Princess Casino sau de partenerii furnizori de jocuri. Verifică termenii fiecărei curse în parte pentru a descoperi cum poți participa și câștiga premii.</span>
            <p><strong>Cursa Book of GEMS</strong></p>
            <span>Promoţia este deschisă participării tuturor persoanelor fizice cu vârsta de peste 18 ani, cu capacitate deplină de exerciţiu si care au un cont activ si verificat pe website-ul <TrackingLink
                href="https://www.princesscasino.ro/">PrincessCasino.ro</TrackingLink>.</span>
            <span>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din promoție.</span>
            <span>Cursa Book of GEMS se desfășoară în perioada 28 ianuarie 2021, orele 14:00 - 7 Februarie 2021, orele 14:00.</span>
            <p><strong>Participare</strong></p>
            <span>Joacă la noul slot Book of Gems de la Skywind și participi automat la cursă.</span>
            <span>Nu există pariu minim pentru participarea în această campanie.</span>
            <span>Fiecare pariu de 1 RON îți aduce 1 punct în cursă, indiferent dacă este câștigător sau nu.</span>
            <span>Punctajul unui jucător este suma pariurilor realizate la slotul Book of Gems, cu bani cash, în perioada desfășurării competiției.</span>
            <p><strong>Premii</strong></p>
            <span>Adună cât mai multe puncte și califică-te în top 100 pentru un premiu cash.</span>
            <div className="terms-table">
                <div className="terms-table-header">
                    <div className="terms-table-row">
                        <div className="terms-table-data"><strong>Locul</strong></div>
                        <div className="terms-table-data"><strong>Premii</strong></div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">1</div>
                        <div className="terms-table-data">3,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">2</div>
                        <div className="terms-table-data">2,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">3</div>
                        <div className="terms-table-data">1,500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">4</div>
                        <div className="terms-table-data">1,250 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">5</div>
                        <div className="terms-table-data">1,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">6-10</div>
                        <div className="terms-table-data">750 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">11-15</div>
                        <div className="terms-table-data">500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">16-20</div>
                        <div className="terms-table-data">250 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">21-30</div>
                        <div className="terms-table-data">200 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">31-50</div>
                        <div className="terms-table-data">150 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">51-75</div>
                        <div className="terms-table-data">100 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">76-100</div>
                        <div className="terms-table-data">50 RON</div>
                    </div>
                </div>
            </div>
            <span>Premiile vor fi acordate în balanța CASH, în următoarele 48 de ore de la încheierea competiției.</span>
            <span>Câștigătorii vor fi notificați pe email și SMS.</span>
            <span>În cazul în care este egalitate de puncte între doi jucători, suma totală rulată va fi folosită ca un criteriu de departajare. În situația în care este egalitate perfectă de puncte și de sumă totală rulată pe perioada promoției, premiul va fi împărțit între jucători.</span>
            <span>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și
                excluse din promoție în scopuri de punctaj.</span>
            <span>Oferta respectă Termenii și Condițiile Princess Casino.</span>
            <span>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii,
                fără explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine
                Regulilor Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va
                prevala.</span>
            <span>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi
                multiple.</span>
            <span>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte
                fără notificare prealabilă.</span>
            <span>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                asistență la adresa de e-mail <a href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.</span>
        </>
    )
}